
import React, { useState } from "react";
import Nav from '../../components/breadcrumb';
import PageHeader, { Title } from '../../components/pageheader';
import { returnStorePackingList } from "../../resources/api/jobs";
import { Col, Form, Row } from "react-bootstrap";
import { errorAlert, successAlert } from "../../components/toastr";

import { useNavigate } from "react-router-dom";
import { CancelButton, SubmitButton } from "../../components/btns";


/**
 * 
 * @param {Object} props
 * @param {import("../../resources/api/jobs").JobObject} props.details
 * @param {import("../../resources/api/jobs").PackingListObject[]} props.items
 * @param {(job: import("../../resources/api/jobs").PackingListObject[]) => void} props.setItems
 */
const ReturnPackingList = ({ details, items: PLItems, setItems: updateItems }) => {

    const nav_items = [
        { title: 'Jobs', href: "/app/jobs" },
        { title: details.job_no, href: `/app/jobs/${details.id}` },
        { title: "Packing List", href: `/app/jobs/${details.id}/packing-list` },
        { title: "Return" }
    ]

    const [items, setItems] = useState(PLItems);


    const [validated, setValidated] = useState(false);
    const [isSubmitting, setSubmitting] = useState(false);

    const navigate = useNavigate();





    /**
     * Update an item in the list
     * @param {number} index 
     * @param {import('../resources/api/invoices').InvoiceItemObject} value 
     */
    const updateItem = (index, value) => {
        let current_items = [...items];
        value.hasChanged = true;
        current_items.splice(index, 1, value);
        setItems(current_items);
    }





    /**
 * handle the overall submitting of the form
 * @param {React.FormEvent} e
 */
    const handleSubmit = e => {
        const form = e.currentTarget;

        e.preventDefault();

        if (!form.checkValidity()) {
            setValidated(true);
            errorAlert("You have errors in your form. These have been highlighted for you.", "Form Errors");
            return;
        }

        setValidated(false);
        setSubmitting(true);

        let promise = returnStorePackingList({
            updated_items: items.filter(i => (!!i.id && i.hasChanged))
        }, details.id);


        promise
            .then(({ items, message }) => {
                successAlert(message);
                updateItems(items);
                navigate(`/app/jobs/${details.id}/packing-list`)
            })
            .catch(e => {
                errorAlert(e);
                setSubmitting(false);
            })
    }


    return (
        <>
            <Nav items={nav_items} />

            <PageHeader maxWidth="1000">
                <Title>{details.title} - Return Packing List</Title>
            </PageHeader>

            <div className="max-1000">

                <Form className="max-800" validated={validated} noValidate onSubmit={handleSubmit}>
                    <Row className="d-none d-sm-flex">
                        <Col sm={5} className="py-0">
                            <Form.Label className="form-field-title">Title</Form.Label>
                        </Col>
                        <Col sm={3} className="py-0">
                            <Form.Label className="form-field-title">Quantity</Form.Label>
                        </Col>
                        <Col sm={4} className="py-0">
                            <Form.Label className="form-field-title">Returned</Form.Label>
                        </Col>
                    </Row>
                    {items.map((e, i) => <ListItem
                        key={i} details={e}
                        onChange={value => updateItem(i, value)}
                    />)}



                    <Row>
                        <Col className="mt-3 mt-sm-5 mb-3 text-end">
                            <SubmitButton isSubmitting={isSubmitting} type="submit">
                                Update List
                            </SubmitButton>
                            <CancelButton isSubmitting={isSubmitting} onClick={() => navigate(-1)}>
                                Cancel
                            </CancelButton>
                        </Col>
                    </Row>
                </Form>
            </div>
        </>
    )

}


/**
 * 
 * @param {Object} props
 * @param {import('../resources/api/invoices').InvoiceItemObject} props.details
 * @param {(item: import('../resources/api/invoices').InvoiceItemObject) => void } props.onChange
 * @param {(index: number) => void } props.onDelete
 */
const ListItem = ({ details, onChange }) => {

    const { Label, Control } = Form;

    return (
        <div className="my-3 pb-1 pb-sm-0 my-sm-1 border-bottom">
            <Row className="label-sm-hide g-1">
                <Col sm={5} className="my-1">
                    <div>
                        <Label className="form-field-title">Title</Label>
                        <Control
                            size="sm"
                            value={details.name}
                            disabled
                        />
                    </div>
                </Col>
                <Col sm={3} className="my-1">
                    <Label className="form-field-title">Qty</Label>
                    <Control
                        size="sm"
                        value={details.quantity}
                        type="number"
                        min="1"
                        disabled
                    />
                    <Control.Feedback type="invalid">
                        Quantity must not be less than 1.
                    </Control.Feedback>
                </Col>
                <Col sm={4} className="my-1">
                    <Label className="form-field-title">Qty</Label>
                    <Control
                        size="sm"
                        value={details.returned}
                        onChange={e => onChange(({ ...details, returned: e.currentTarget.value }))}
                        type="number"
                        min="1"
                        max={details.quantity}
                        required
                    />
                    <Control.Feedback type="invalid">
                        Quantity must not be less than 1 and more than quantity taken out
                    </Control.Feedback>
                </Col>
            </Row>
        </div>
    )
}






export default ReturnPackingList;